/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Tlm_0Inputs */

const en_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`image_stack`)
};

const ar_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية الصور`)
};

const bn_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ছবি স্ট্যাক`)
};

const de_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild-Stack`)
};

const es_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack de imagen`)
};

const fr_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack d'image`)
};

const pt_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack de imagem`)
};

const zh_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片技术栈`)
};

const tr_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görsel altyapısı`)
};

const ru_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стек картинок`)
};

const pl_svc_ai_image_pod_automation_tlm_0 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stos obrazów`)
};

/**
* | output |
* | --- |
* | "image_stack" |
*
* @param {Svc_Ai_Image_Pod_Automation_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_tlm_0 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_tlm_0(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_tlm_0(inputs)
	return en_svc_ai_image_pod_automation_tlm_0(inputs)
});
export { svc_ai_image_pod_automation_tlm_0 as "svc_ai-image-pod-automation_tlm_0" }